export default __webpack_public_path__ + "static/real_estate-cc389a14dbef65dd03fc75358cc0d7dc.png";